import React, { Component } from 'react';
import NavbarItem from './navbar.item.component';

class NavBarItemList extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }

    handleItemClickEvent() {
        this.props.handleClickEvent(false);
    }
      
	render() {
    	return (
            <div>
                <ul className="navbar-nav mr-auto">
                    <NavbarItem key="navMenuItemNews" name="Neuigkeiten" url="neuigkeiten" badge="" handleClickEvent={this.handleItemClickEvent.bind(this)} />
                    <NavbarItem key="navMenuItemKita" name="Förderverein" url="" handleClickEvent={this.handleItemClickEvent.bind(this)} />
                    <NavbarItem key="navMenuItemVorstand" name="Vorstand" url="vorstand" handleClickEvent={this.handleItemClickEvent.bind(this)} />
                    <NavbarItem key="navMenuItemFormulare" name="Beitritt" url="beitreten" handleClickEvent={this.handleItemClickEvent.bind(this)} />
                    <NavbarItem key="navMenuItemSatzung" name="Satzung" url="satzung" handleClickEvent={this.handleItemClickEvent.bind(this)} />
                </ul>
            </div>
    	);
  	}
}

export default NavBarItemList;


// WEBPACK FOOTER //
// ./src/components/navbar.itemlist.component.js